import type { SVGProps } from 'react';

const SvgAutoViewingPictogram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 50 50'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M40.583 14.771a1.555 1.555 0 1 0-2.417 1.958c2.354 2.917 3.667 6.375 3.792 10 .333 9.334-7 17.209-16.355 17.521-9.333.333-17.208-7-17.52-16.354-.313-9.354 7-17.208 16.354-17.52 1.187-.043 2.437.062 3.791.333.084.02.167 0 .25 0 .209.104.459.166.688.166.354 0 .687-.104.98-.354.666-.542.77-1.52.25-2.188L26.27 3.188c-.542-.667-1.52-.792-2.187-.25a1.577 1.577 0 0 0-.25 2.187l1.729 2.146c-.396-.02-.813-.042-1.209-.02C13.292 7.624 4.604 16.957 5 28.02c.396 11.063 9.709 19.75 20.771 19.354 11.063-.396 19.75-9.708 19.354-20.77-.208-4.292-1.75-8.396-4.541-11.834Z'
      fill='#BCDEFF'
    />
    <path
      d='m18.608 20.963 9.954-3.321c4.469-1.49 6.897.949 5.418 5.418l-3.322 9.954c-2.229 6.698-5.893 6.698-8.122 0l-.982-2.958-2.957-.982c-6.687-2.218-6.687-5.87.01-8.11Z'
      fill='#4D9DFF'
    />
    <path
      d='M24.136 28.05a.819.819 0 0 1-.585-.243.833.833 0 0 1 0-1.17l4.193-4.215c.32-.32.85-.32 1.17 0 .32.32.32.85 0 1.17l-4.194 4.215a.867.867 0 0 1-.584.243Z'
      fill='#BCDEFF'
    />
  </svg>
);
export default SvgAutoViewingPictogram;
